import { useEffect, useState } from 'react';
import { useDebounceCallback } from '@react-hook/debounce';
import { getProjectIterations } from 'common/services/pdt.service';
import { orderBy } from 'lodash';
import { FETCH_STATUSES } from 'common/constants/constants';
import {
  formatIterationRange,
  KANBAN_TYPES
} from 'state/selectors/iterations-picker';
import useProjectByPdtId from 'state/selectors/hooks/useProjectByPdtId';

const usePdtIterations = pdtId => {
  const [status, setStatus] = useState(FETCH_STATUSES.IDLE);
  const [pdtIterations, setPdtIterations] = useState([]);
  const project = useProjectByPdtId(pdtId);
  const cadence = project?.metadata?.cadence?.type;

  const formatPdtIteration = pdtIteration => {
    const isKanban = KANBAN_TYPES.includes(cadence.toLowerCase());
    const { name, start, end, completed } = pdtIteration;

    const range = formatIterationRange({
      start_date: start,
      end_date: completed || end
    });
    const computedName = isKanban ? `Week ${name.split('-')[1]}` : `${name}`;
    const computedNameWithRange = `${computedName} (${range})`;

    return {
      ...pdtIteration,
      computedName: computedNameWithRange,
      start_date: start,
      end_date: end
    };
  };

  const fetchPdtIterations = useDebounceCallback(async () => {
    try {
      const resIterations = await getProjectIterations(pdtId);
      const orderedIterations = orderBy(
        resIterations.filter(Boolean),
        ['start', 'end'],
        ['desc', 'desc']
      );
      const formattedIterations = orderedIterations.map(formatPdtIteration);
      setPdtIterations(formattedIterations);
    } catch (e) {
    } finally {
      setStatus(FETCH_STATUSES.FINISHED);
    }
  }, 200);

  useEffect(() => {
    if (pdtId) {
      setStatus(FETCH_STATUSES.LOADING);
      fetchPdtIterations();
    } else {
      setPdtIterations([]);
    }
  }, [pdtId]);

  return {
    status,
    pdtIterations
  };
};

export default usePdtIterations;
